export const getTestId = (suffix, dataTestId) => (dataTestId ? `${dataTestId}-${suffix}` : suffix);
export const applyLink = (editor, href) => {
    const trimmed = href.trim();
    const chain = editor.chain().focus().extendMarkRange('link');
    (trimmed ? chain.setLink({ href: trimmed }) : chain.unsetLink()).run();
};
